export const API_KEY = 'ewr1-HZgBuNoJZFDJGk4h6OgjIn';
